import {Injectable} from "@angular/core";
import {Observable} from "rxjs/Observable";
import * as _ from "underscore";
import {ILock, IRemoteLockResult, User} from "../definitions";
import {clamp01} from "../utils";
import {AuthService} from "./auth.service";
import {BusService} from "./bus.service";
import {SockService} from "./sock.service";

@Injectable()
export class LockService {
  private user: User;

  public locks: ILock[] = []; // todo: ILock


  constructor(private socketService: SockService,
              private authService: AuthService,
              private busService: BusService) {
    this.busService
      .onLocksTimedOut
      .subscribe(documentIds => this.onLocksTimedOut(documentIds));

    this.authService
      .authenticated()
      .subscribe((user: User) => this.user = user);

    setInterval(this.tick.bind(this), 500);
  }


  private onLocksTimedOut(documentIds: string[]) {
    documentIds.forEach(
      id => this.removeLock(id));
  }


  lock(documentId: string): Observable<IRemoteLockResult> {
    if (this.user.access !== "full") {
      // fake response
      return Observable.of(<IRemoteLockResult>{result: false, user: {displayName: "system"}});
    }

    return this.socketService.sendEvent("lock", {_id: documentId, user: this.user})
      .map((response: IRemoteLockResult) => {
        if (response.result) {
          this.addLockRecord(documentId, response.timeout as number);
        }
        return response;
      });
  }


  prolong(documentId: string) {
    let data = {_id: documentId, user: this.user};
    this.socketService.sendEvent("prolong", data)
      .subscribe(
        response => {
          let result = response.result as boolean;
          if (!result) {
            return false;
          }

          this.updateLockRecord(documentId, response.timeout as number);
          return true;
        });
  }


  unlock(documentId: string): Observable<boolean> {
    let data = {_id: documentId, user: this.user};
    return this.socketService.sendEvent("unlock", data)
      .map(
        response => {
          let result = response.result as boolean;
          if (result) {
            this.removeLock(documentId);
            return true;
          }
          return false;
        });
  }


  getTimeleftRatio(documentId: string): number {
    let record = this.getLockRecord(documentId);
    if (!record) {
      return 0;
    }

    let elapsed = clamp01((Date.now() - record.started) / record.timeout);
    return 1.0 - elapsed;
  }


  private removeLock(documentId: string) {
    this.locks = _.filter(this.locks, (l: ILock) => l._id != documentId);
    this.busService.emitDocumentLockRemoved(documentId);
  }


  private updateLockRecord(documentId: string,
                           timeout: number) {
    for (let i = 0; i < this.locks.length; ++i) {
      let lock = this.locks[i];
      if (lock._id === documentId) {
        lock.started = Date.now();
        lock.timeout = timeout;
        return;
      }
    }
  }


  private getLockRecord(documentId: string): ILock {
    for (let i = 0; i < this.locks.length; ++i) {
      if (this.locks[i]._id === documentId) {
        return this.locks[i];
      }
    }
    return null;
  }


  private addLockRecord(documentId: string,
                        timeout: number) {
    if (this.getLockRecord(documentId)) {
      return this.updateLockRecord(documentId, timeout);
    }


    let record: ILock = {
      _id: documentId,
      timeout: timeout,
      started: Date.now()
    };
    this.locks.push(record);
  }


  private tick() {
    let now = Date.now();
    for (let i = this.locks.length - 1; i >= 0; --i) {
      let lock = this.locks[i];
      if (lock.started + lock.timeout < now) {
        this.locks.splice(i, 1);
      }
    }
  }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/services/lock.service.ts